import * as S from "./ArticleList.style";
import { ArticleItem } from "@/components/atoms/ArticleItem";

interface ArticleListProps {
  data?: any;
}

export const ArticleList = ({ data }: ArticleListProps) => {
  const sortData = data
    .filter((item: any) => {
      return item.isActive;
    })
    .sort((a: any, b: any) => {
      if (a.isFixed && !b.isFixed) return -1;
      if (!a.isFixed && b.isFixed) return 1;

      if (a.isFixed === b.isFixed) {
        return (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      }

      return 0;
    });
  return (
    <S.ArticelList>
      {sortData.map((item: any, idx: number) => {
        return <ArticleItem data={item} key={idx} />;
      })}
    </S.ArticelList>
  );
};
